import Masthead from '@/pages/home/components/Masthead';
import Hero from '@/pages/home/components/Hero';
import EntryGateway from '@/pages/home/components/EntryGateway';
import AccessBoard from '@/pages/home/components/AccessBoard';
import TrendingBoard from '@/pages/home/components/TrendingBoard';
import DiscussionFeed from '@/pages/home/components/DiscussionFeed';
import VisitGuide from '@/pages/home/components/VisitGuide';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Masthead />
      <main>
        <Hero />
        <EntryGateway />
        <AccessBoard />
        <TrendingBoard />
        <DiscussionFeed />
        <VisitGuide />
      </main>
      <SiteFooter />
    </div>
  );
}